module.exports = __webpack_public_path__ + "img/debu.9922efa1.jpeg";